import ApiService from '../api/ApiService';

export default async function updateFinalPrice(data) {
  const rawResponse = await ApiService('updateFinalPrice', { recordId: data.recordId }, null, JSON.stringify(data));
  return rawResponse.data;
}
